/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/concatMapTo */
import{concatMap as c}from"rxjs/dist/esm/internal/operators/concatMap";import{isFunction as n}from"rxjs/dist/esm/internal/util/isFunction";function m(o,t){return n(t)?c(()=>o,t):c(()=>o)}export{m as concatMapTo};
//# sourceMappingURL=concatMapTo.mjs.map